import { render } from "./LangBar.vue?vue&type=template&id=7bed9d9c"
import script from "./LangBar.vue?vue&type=script&lang=ts"
export * from "./LangBar.vue?vue&type=script&lang=ts"
script.render = render

export default script